export const getClassNames = (...names: (string | false | undefined)[]) => {
  return names
    .map((item) => (item !== false && item ? item.trim() : ""))
    .filter((item) => item)
    .join(" ");
};
